import React from 'react';

const ShimmerLoader = ({ 
  width = '100%', 
  height = '200px', 
  className = '',
  lines = 3,
  showGraph = true 
}) => {
  return (
    <div className={`w-full h-full bg-gray-50 flex items-center justify-center ${className}`}>
      <div className="w-full max-w-6xl mx-auto p-6">
        {/* Main shimmer container */}
        <div className="space-y-6">
          {/* Header shimmer */}
          <div className="flex items-center justify-between">
            <div className="h-8 bg-gray-200 rounded-lg w-64 animate-pulse"></div>
            <div className="h-8 bg-gray-200 rounded-lg w-32 animate-pulse"></div>
          </div>

          {/* Graph area shimmer */}
          {showGraph && (
            <div className="relative bg-white rounded-lg border border-gray-200 p-6" style={{ height: height }}>
              {/* Main token node shimmer */}
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <div className="w-40 h-16 bg-blue-200 rounded-lg animate-pulse"></div>
              </div>

              {/* Repository nodes shimmer */}
              <div className="absolute top-1/4 right-1/4">
                <div className="w-32 h-12 bg-green-200 rounded-lg animate-pulse"></div>
              </div>
              <div className="absolute top-1/4 right-1/4 mt-16">
                <div className="w-24 h-8 bg-cyan-200 rounded-lg animate-pulse"></div>
              </div>
              <div className="absolute top-1/4 right-1/4 mt-28">
                <div className="w-24 h-8 bg-cyan-200 rounded-lg animate-pulse"></div>
              </div>

              {/* Permission nodes shimmer */}
              <div className="absolute bottom-1/4 left-1/4">
                <div className="w-32 h-12 bg-purple-200 rounded-lg animate-pulse"></div>
              </div>
              <div className="absolute bottom-1/4 left-1/4 mt-16">
                <div className="w-24 h-8 bg-pink-200 rounded-lg animate-pulse"></div>
              </div>
              <div className="absolute bottom-1/4 left-1/4 mt-28">
                <div className="w-24 h-8 bg-pink-200 rounded-lg animate-pulse"></div>
              </div>

              {/* Slack specific nodes shimmer */}
              <div className="absolute bottom-1/6 left-1/6">
                <div className="w-20 h-8 bg-blue-200 rounded-lg animate-pulse"></div>
              </div>
              <div className="absolute bottom-1/6 left-1/6 ml-24">
                <div className="w-20 h-8 bg-orange-200 rounded-lg animate-pulse"></div>
              </div>
              <div className="absolute bottom-1/6 left-1/6 ml-48">
                <div className="w-20 h-8 bg-green-200 rounded-lg animate-pulse"></div>
              </div>
              <div className="absolute bottom-1/6 left-1/6 ml-72">
                <div className="w-20 h-8 bg-red-200 rounded-lg animate-pulse"></div>
              </div>
              <div className="absolute bottom-1/6 left-1/6 ml-96">
                <div className="w-20 h-8 bg-indigo-200 rounded-lg animate-pulse"></div>
              </div>

              {/* Connection lines shimmer */}
              <svg className="absolute inset-0 w-full h-full pointer-events-none">
                <line x1="50%" y1="50%" x2="75%" y2="25%" stroke="#e5e7eb" strokeWidth="2" className="animate-pulse" />
                <line x1="50%" y1="50%" x2="25%" y2="75%" stroke="#e5e7eb" strokeWidth="2" className="animate-pulse" />
                <line x1="75%" y1="25%" x2="75%" y2="35%" stroke="#e5e7eb" strokeWidth="1" className="animate-pulse" />
                <line x1="75%" y1="25%" x2="75%" y2="45%" stroke="#e5e7eb" strokeWidth="1" className="animate-pulse" />
                <line x1="25%" y1="75%" x2="25%" y2="85%" stroke="#e5e7eb" strokeWidth="1" className="animate-pulse" />
                <line x1="25%" y1="75%" x2="25%" y2="95%" stroke="#e5e7eb" strokeWidth="1" className="animate-pulse" />
              </svg>
            </div>
          )}

          {/* Bottom panels shimmer */}
          <div className="flex gap-4">
            {/* Legend panel shimmer */}
            <div className="flex-1 bg-white rounded-lg shadow-lg border border-gray-200 p-4">
              <div className="space-y-3">
                <div className="h-6 bg-gray-200 rounded w-48 animate-pulse"></div>
                <div className="space-y-2">
                  {Array.from({ length: lines }).map((_, i) => (
                    <div key={i} className="flex items-center space-x-2">
                      <div className="w-4 h-4 bg-gray-200 rounded-full animate-pulse"></div>
                      <div className="h-4 bg-gray-200 rounded w-32 animate-pulse"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Token details panel shimmer */}
            <div className="flex-1 bg-white rounded-lg shadow-lg border border-gray-200 p-4">
              <div className="space-y-2">
                <div className="h-6 bg-gray-200 rounded w-32 animate-pulse"></div>
                <div className="space-y-1">
                  {Array.from({ length: lines + 2 }).map((_, i) => (
                    <div key={i} className="flex justify-between">
                      <div className="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
                      <div className="h-4 bg-gray-200 rounded w-24 animate-pulse"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShimmerLoader;
